import dismissDashboardCard from "./dismissDashboardCard";
import getDashboardCards from "./getDashboardCards";
import getSideLinks from "./getSideLinks";

const mockResponses = { getDashboardCards, dismissDashboardCard, getSideLinks };

export default mockResponses;
